<template>
  <div class="bgimg">
    <h1>锐捷通app下载</h1>
    <div class="flex">
      <div>
        <p>安卓-学生端</p>
        <img src="../assets/img/android-student.png" alt="" />
      </div>
      <div>
        <p>安卓-教师端</p>
        <img src="../assets/img/android-teacher.png" alt="" />
      </div>
      <div>
        <p>ios-学生端</p>
        <img src="../assets/img/ios-student.png" alt="" />
      </div>

      <div>
        <p>ios-教师端</p>
        <img src="../assets/img/ios-teacher.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.bgimg {
  width: 100vw;
  height: 100vh;
  background-image: url(../assets/img/bg.jpg);
  background-size: 100% 100%;
  background-size: cover;
  color: white;
  overflow: hidden;
}
h1 {
  text-align: center;
  position: relative;
  top: 40%;
}
.flex {
  height: 400px;
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-evenly;
}
.flex div {
  width: 25%;
}
.flex img {
  width: 300px;
}
</style>
